function roundTwo(value) {
	return Math.round(value * 100) / 100;
}

function formatDollar(value) {
	if (value === 0 || value === null || value === undefined) return "–";
	let absolute = Math.abs(Math.round(value)).toLocaleString("en-CA");
	if (value < 0) return "($" + absolute + ")";
	return "$" + absolute;
}

const AnalyticsSummaryService = {
	/**
	 * Derives summary analytics (current ratio, gross/net margin, net income) from a compiled
	 * balance sheet and income statement.
	 * @param {Object} params { balanceSheet, incomeStatement }
	 * @return {Object} { currentRatio, grossMargin, netMargin, netIncome, netIncomeRaw }
	 */
	computeAnalyticsSummary({ balanceSheet, incomeStatement }) {
		let currentAssets = 0;
		let currentLiabilities = 0;
		let revenue = 0;
		let cogs = 0;

		for (let section of (balanceSheet?.sections || [])) {
			if (section.category === "current-assets") currentAssets += section.totalCurrent;
			if (section.category === "current-liabilities") currentLiabilities += section.totalCurrent;
		}

		for (let section of (incomeStatement?.sections || [])) {
			if (section.category === "revenue") revenue += section.totalCurrent;
			if (section.category === "cogs") cogs += section.totalCurrent;
		}

		let grossProfit = revenue - cogs;
		let netIncomeValue = incomeStatement?.netIncome?.current || 0;

		return {
			currentRatio: currentLiabilities !== 0 ? roundTwo(currentAssets / currentLiabilities) : "N/A",
			grossMargin: revenue !== 0 ? roundTwo((grossProfit / revenue) * 100) + "%" : "N/A",
			netMargin: revenue !== 0 ? roundTwo((netIncomeValue / revenue) * 100) + "%" : "N/A",
			netIncome: formatDollar(netIncomeValue),
			netIncomeRaw: netIncomeValue,
		};
	},
};

export default AnalyticsSummaryService;
